import { HistoryMessage } from '../types/chat';
import axios from 'axios';
import { ApiResponse } from '../types/common';

export interface SSEData {
    id: string;
    content?: string;
    type?: string;
    ui_type?: string;
    ui_data?: any;
    data_source?: any;
    info_card_options?: any;
    confirm_options?: any;
}

interface PaginatedMessages {
    messages: HistoryMessage[];
    total: number;
    page: number;
    pageSize: number;
}

export const getChatHistory = async (
    accountId: string,
    threadId: string,
    page: number = 1,
    pageSize: number = 20,
    sortDirection: number = -1
): Promise<PaginatedMessages> => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_API_BASE_URL}/api/chat/${threadId}/messages?page=${page}&page_size=${pageSize}&sort_direction=${sortDirection}&account_id=${accountId}`
        );
        if (!response.ok) {
            throw new Error('获取历史记录失败');
        }
        const result = await response.json();
        return result.data;
    } catch (error) {
        console.error('获取历史记录错误:', error);
        return {
            messages: [],
            total: 0,
            page: page,
            pageSize: pageSize
        };
    }
};

export const connectToSSE = (message: string, accountId: string, threadId: string): EventSource => {
    const eventSource = new EventSource(`${process.env.REACT_APP_API_BASE_URL}/api/chat/${threadId}/stream?message=${encodeURIComponent(message)}&account_id=${accountId}`);

    return eventSource;
};

// 将音频转换为文本
export async function convertAudioToText(audioUrl: string): Promise<string> {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/chat/audio-to-text`, {
            params: {
                url: audioUrl
            }
        });
        return response.data.data;
    } catch (error) {
        console.error('音频转文字失败:', error);
        throw error;
    }
}

// 保存UI消息状态
export const saveMessageState = async (messageId: string, uiState: any): Promise<boolean> => {
    try {
        const response = await axios.put<ApiResponse<any>>(
            `${process.env.REACT_APP_API_BASE_URL}/api/chat/messages/${messageId}/state`,
            { ui_state: uiState }
        );
        return response.status === 200;
    } catch (error) {
        console.error('保存消息状态失败:', error);
        return false;
    }
};

/**
 * 获取建议问题列表
 * @param threadId 对话线程ID
 * @returns 建议问题列表
 */
export const getSuggestedQuestions = async (threadId: string, accountId: string): Promise<any> => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/chat/${threadId}/suggested-questions?limit=3&account_id=${accountId}`);
        if (!response.ok) throw new Error('获取建议问题失败');
        const data = await response.json();
        return data.data;
    } catch (error) {
        console.error('获取建议问题失败:', error);
        return null;
    }
}; 